import React from 'react';
import _ from 'lodash'
import { Dispatch } from 'architecture'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { faEdit } from '@fortawesome/free-solid-svg-icons'

export default (props) => {
  const data = props.data
  const tag = data.tag
  const onRemove = data.onRemove
  const onEdit = data.onEdit
  return (
    <div className={'pv2 pl3 pr2 mr2 mt1 mb1 br2 white tl flex pointer Tag bg-' +tag.color}
      onClick={e => Dispatch.nextAction('Search', 'addTag', tag.id) }
      //onMouseDown={e => Dispatch.nextAction('Tag', 'mouseDown', {tag: tag.id, event: e} )}
      >
      <div className='Tag'> {tag.name} </div>
      { tag.removeable !== false ?
        <div className='relative pl2 pr1 f6 pointer' style={{top:2}} 
        onClick={(e) => {
          e.stopPropagation()
          //e.preventDefault()
          onRemove(tag.id)
        }}>
          <FontAwesomeIcon icon={faTimes}/>
        </div>
        :
        <div className='pr2 '>
        </div>
      }
       { tag.editable === true ?
        <div className='relative pl2 pr1 f7 pointer moon-gray' style={{top:2}} 
        onClick={(e) => {
          e.stopPropagation()
          //e.preventDefault()
          Dispatch.nextAction('Tags', 'edit', tag.id)
        }}>
          <FontAwesomeIcon icon={faEdit}/>
        </div>
        :
        <div className='pr2 '>
        </div>
      }
    </div>
  )
}